import { useStore } from "@nanostores/react";

import {
  currentTrackId,
  reproduceTrack,
  trackReproduced,
} from "@/stores/player/playerStore";

import { PlayPauseButton } from "../track/track-reproduce/PlayPauseButton";
import { PlayerTrackProgress } from "@/components/shared/player/PlayerTrackProgress";

export const PlayerAction = () => {
  const track = useStore(trackReproduced);
  const $currentTrackId = useStore(currentTrackId);

  if (!track) return null;

  return (
    <div className="hidden w-[447px] items-center md:flex md:flex-grow md:flex-col md:justify-center md:gap-y-2">
      <PlayPauseButton
        player
        track={track}
        isPlaying={$currentTrackId === track.id}
        onClick={() => reproduceTrack(track)}
        aria-label={$currentTrackId === track.id ? "Pause" : "Play"}
      />
      <div className="hidden w-full md:block">
        <PlayerTrackProgress />
      </div>
    </div>
  );
};
